import { useState, useEffect, useContext } from 'react';

function Loading(props: any) {
  const loadingWidth = props.width ? props.width : '15%';
  const isWhite = props.isWhite;

  return (
    <div className="text-center">
      {isWhite ? (
        <img
          src="/images/svg/spinner.svg"
          width={loadingWidth}
          alt="loading"
          style={{
            filter: 'brightness(0) invert(1)',
          }}
        />
      ) : (
        <img src="/images/svg/spinner.svg" width={loadingWidth} alt="loading" />
      )}
    </div>
  );
}

export default Loading;